var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountDeletion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 29,
    viewBox: "0 0 119 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.735 2.69936V1.20129H116.831V2.69936H118.396V26.1025H116.831V27.5673H115.233V2.69936H113.735ZM95.4922 20.0104V18.3458H97.9224V16.6813H100.053V15.0168H102.184V13.3523H104.314V11.6878H106.445V4.6302H96.158V3.23201H108.242V4.56362H109.84V11.6878H108.176V13.3523H105.879V15.0168H103.781L103.748 16.6813H101.618V18.3458H99.487V20.0104H95.4922Z",
    fill: "#1A1918",
    stroke: "black",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1041 2.03359V5.42921H80.1284V6.79412H62.4512V5.42921H69.9415V2.03359H68.277V0.535522H71.5394V2.03359H73.1041ZM64.4486 17.6801V12.1539H66.0132V10.8223H67.5779V9.49064H75.501V10.8223H77.0989V12.1539H78.6303V17.6801H77.0989V19.045H75.501V20.4432H67.5779V19.045H66.0132V17.6801H64.4486ZM67.5779 17.6801H69.1425V19.045H73.9031V17.6801H75.501V12.1872H73.9031V10.8223H69.1425V12.1872H67.5779V17.6801ZM81.5931 2.6994V1.20133H84.6892V2.6994H86.2538V11.7211H91.3139V13.1859H86.2538V26.1025H84.6892V27.5673H83.0912V2.6994H81.5931Z",
    fill: "#1A1918",
    stroke: "black",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0476 2.69936H56.6122V26.1025H55.0476V27.5673H53.4497V2.69936H51.9516V1.20129H55.0476V2.69936ZM31.6777 22.6403V21.1755H40.2999V18.0462H38.7686V16.5482H41.8313V18.0462H43.3627V21.1755H51.1193V22.6403H31.6777ZM33.6419 13.7851V4.2973H35.2731V2.8991H47.99V4.2973H36.9376V8.15899H47.6571V9.4906H36.9376V13.7851H46.7916V12.4867H49.7877V13.8516H48.3229V15.2165H35.2398V13.7851H33.6419Z",
    fill: "#1A1918",
    stroke: "black",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6375 7.69292H28.6976V9.19099H23.6375V14.118H22.0728V15.5827H20.4749V2.69936H18.9768V1.20129H22.0728V2.69936H23.6375V7.69292ZM1 12.2537V3.2653H2.56465V1.8671H15.1151V3.2653H4.22917V6.96053H14.6158V8.39202H4.22917V12.2537H14.9154V10.8555H17.9115V12.3536H16.4135V13.6852H2.53136V12.2537H1ZM5.79382 26.502V23.2395H7.45834V21.7415H19.1433V18.6787H6.12672V17.2473H22.4723V21.6416H20.8078V23.1397H9.12286V26.502H23.8705V28.0001H7.45834V26.502H5.79382Z",
    fill: "#1A1918",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDeletion);
export default __webpack_public_path__ + "static/media/AccountDeletion.42f0623457eadc4e44f444839924880f.svg";
export { ForwardRef as ReactComponent };